/**
 * @generated SignedSource<<03b68e543b1cccb86716cfd9041114ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentSubmissionStatus = "active" | "failed" | "passed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type StatusColumn_ContentSubmissionFragment$data = {
  readonly definition: {
    readonly status: ContentSubmissionStatus;
  };
  readonly " $fragmentType": "StatusColumn_ContentSubmissionFragment";
};
export type StatusColumn_ContentSubmissionFragment$key = {
  readonly " $data"?: StatusColumn_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusColumn_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatusColumn_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "31d1530d3f81332075ea8d865c3c8a61";

export default node;
